/* istanbul ignore file */
import { useSWR } from '@ori/fetching';
import type { StaticLanguagesLanguage } from '@ori/static-api-client-react';
import { ApiClient, getTenantLanguages } from '@ori/static-api-client-react';
import { useCallback, useMemo } from 'react';

/**
 * React hook for getting languages for provided tenant
 */
export const useTenantLanguages = (baseUrl: string, tenant: string, disabled?: boolean) => {
  // We create api client by ourselves, because we do not need any context for this simple app
  const apiClient = useMemo(() => new ApiClient({ baseUrl, tenant }), [baseUrl, tenant]);
  const fetcher = useCallback(
    async (incomingTenant: string): Promise<StaticLanguagesLanguage[]> => {
      const {
        data: { languages },
      } = await getTenantLanguages(apiClient, incomingTenant);

      // It may happen that languages are an object instead of plain array
      return Object.values(languages);
    },
    [apiClient],
  );

  return useSWR([tenant, 'languages'], fetcher, {
    isPaused: () => !!disabled,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
};
